import React, { useState } from "react";
import { blissfuldays } from "../assets/";
import { Link } from "react-router-dom";

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="bg-white text-neutral-800 fixed w-full z-20 top-0 shadow-soft">
      <div className="max-w-screen-xl mx-auto px-6">
        <div className="flex justify-between items-center py-5">
          <div className="flex items-center">
            <Link to="/" className="transition-transform hover:scale-105">
              <img
                className="h-14 w-auto"
                src={blissfuldays}
                alt="Blissful Days Psychiatric Services"
              />
            </Link>
          </div>
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-neutral-700 hover:text-primary-500 focus:outline-none transition-colors"
              aria-label="Toggle menu"
            >
              <svg
                className="w-7 h-7"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16m-7 6h7"
                  />
                )}
              </svg>
            </button>
          </div>
          <div className="hidden md:flex md:items-center flex-grow justify-end">
            <ul className="flex space-x-8 lg:space-x-10">
              <li>
                <Link
                  to="/"
                  className="text-body-md font-medium text-neutral-700 hover:text-primary-500 transition-colors duration-200 relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-primary-500 after:transition-all hover:after:w-full"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-body-md font-medium text-neutral-700 hover:text-primary-500 transition-colors duration-200 relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-primary-500 after:transition-all hover:after:w-full"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/MainServicePage"
                  className="text-body-md font-medium text-neutral-700 hover:text-primary-500 transition-colors duration-200 relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-primary-500 after:transition-all hover:after:w-full"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-body-md font-medium text-neutral-700 hover:text-primary-500 transition-colors duration-200 relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-primary-500 after:transition-all hover:after:w-full"
                >
                  FAQ's
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="px-6 py-2.5 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-all duration-200 shadow-sm hover:shadow-md"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {isOpen && (
          <div className="md:hidden pb-4 animate-fade-in">
            <div className="flex flex-col space-y-3 pt-2 border-t border-neutral-200">
              <Link
                to="/"
                className="text-body-md font-medium text-neutral-700 hover:text-primary-500 py-2 transition-colors"
                onClick={() => setIsOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/about"
                className="text-body-md font-medium text-neutral-700 hover:text-primary-500 py-2 transition-colors"
                onClick={() => setIsOpen(false)}
              >
                About
              </Link>
              <Link
                to="/MainServicePage"
                className="text-body-md font-medium text-neutral-700 hover:text-primary-500 py-2 transition-colors"
                onClick={() => setIsOpen(false)}
              >
                Services
              </Link>
              <Link
                to="/faq"
                className="text-body-md font-medium text-neutral-700 hover:text-primary-500 py-2 transition-colors"
                onClick={() => setIsOpen(false)}
              >
                FAQ's
              </Link>
              <Link
                to="/contact"
                className="text-center px-6 py-2.5 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-all mt-2"
                onClick={() => setIsOpen(false)}
              >
                Contact
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default NavBar;
